// Space reserved for the centered chat header title so it cannot paint
// over the hamburger (left) or New Chat / pin / find / details / menu (right).
// Icon-only nav buttons are 40px; padding and a small gap are included.
export const CHAT_HEADER_LEFT_ACTIONS_WIDTH = 64;
export const CHAT_HEADER_RIGHT_ACTIONS_WIDTH = 232;
export const CHAT_HEADER_RIGHT_ACTIONS_WIDTH_COMPACT = 152;
export const CHAT_HEADER_TITLE_MIN_WIDTH = 96;

export function getChatHeaderTitleMaxWidth({
  windowWidth = 0,
  navigationSidebarWidth = 0,
  contextSidebarWidth = 0,
  compactActions = false,
} = {}) {
  const headerWidth = Math.max(0, windowWidth - navigationSidebarWidth - contextSidebarWidth);
  // The title is centered in the header, so it needs matching clearance on
  // both sides — whichever action cluster is wider.
  const side = Math.max(
    CHAT_HEADER_LEFT_ACTIONS_WIDTH,
    compactActions
      ? CHAT_HEADER_RIGHT_ACTIONS_WIDTH_COMPACT
      : CHAT_HEADER_RIGHT_ACTIONS_WIDTH,
  );
  return Math.max(CHAT_HEADER_TITLE_MIN_WIDTH, headerWidth - side * 2);
}
